"use client";

import { ChevronDown, Loader, CircleCheck as CheckCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const countries = [{
  code: "+1",
  name: "United States",
  flag: ""
}, {
  code: "+93",
  name: "Afghanistan",
  flag: ""
}, {
  code: "+355",
  name: "Albania",
  flag: ""
}, {
  code: "+213",
  name: "Algeria",
  flag: ""
}, {
  code: "+376",
  name: "Andorra",
  flag: ""
}, {
  code: "+244",
  name: "Angola",
  flag: ""
}, {
  code: "+54",
  name: "Argentina",
  flag: ""
}, {
  code: "+374",
  name: "Armenia",
  flag: ""
}, {
  code: "+61",
  name: "Australia",
  flag: ""
}, {
  code: "+43",
  name: "Austria",
  flag: ""
}, {
  code: "+994",
  name: "Azerbaijan",
  flag: ""
}, {
  code: "+973",
  name: "Bahrain",
  flag: ""
}, {
  code: "+880",
  name: "Bangladesh",
  flag: ""
}, {
  code: "+375",
  name: "Belarus",
  flag: ""
}, {
  code: "+32",
  name: "Belgium",
  flag: ""
}, {
  code: "+501",
  name: "Belize",
  flag: ""
}, {
  code: "+229",
  name: "Benin",
  flag: ""
}, {
  code: "+975",
  name: "Bhutan",
  flag: ""
}, {
  code: "+591",
  name: "Bolivia",
  flag: ""
}, {
  code: "+387",
  name: "Bosnia and Herzegovina",
  flag: ""
}, {
  code: "+267",
  name: "Botswana",
  flag: ""
}, {
  code: "+55",
  name: "Brazil",
  flag: ""
}, {
  code: "+673",
  name: "Brunei",
  flag: ""
}, {
  code: "+359",
  name: "Bulgaria",
  flag: ""
}, {
  code: "+226",
  name: "Burkina Faso",
  flag: ""
}, {
  code: "+257",
  name: "Burundi",
  flag: ""
}, {
  code: "+855",
  name: "Cambodia",
  flag: ""
}, {
  code: "+237",
  name: "Cameroon",
  flag: ""
}, {
  code: "+1",
  name: "Canada",
  flag: ""
}, {
  code: "+238",
  name: "Cape Verde",
  flag: ""
}, {
  code: "+236",
  name: "Central African Republic",
  flag: ""
}, {
  code: "+235",
  name: "Chad",
  flag: ""
}, {
  code: "+56",
  name: "Chile",
  flag: ""
}, {
  code: "+86",
  name: "China",
  flag: ""
}, {
  code: "+57",
  name: "Colombia",
  flag: ""
}, {
  code: "+269",
  name: "Comoros",
  flag: ""
}, {
  code: "+242",
  name: "Congo",
  flag: ""
}, {
  code: "+506",
  name: "Costa Rica",
  flag: ""
}, {
  code: "+385",
  name: "Croatia",
  flag: ""
}, {
  code: "+53",
  name: "Cuba",
  flag: ""
}, {
  code: "+357",
  name: "Cyprus",
  flag: ""
}, {
  code: "+420",
  name: "Czech Republic",
  flag: ""
}, {
  code: "+45",
  name: "Denmark",
  flag: ""
}, {
  code: "+253",
  name: "Djibouti",
  flag: ""
}, {
  code: "+1",
  name: "Dominica",
  flag: ""
}, {
  code: "+1",
  name: "Dominican Republic",
  flag: ""
}, {
  code: "+593",
  name: "Ecuador",
  flag: ""
}, {
  code: "+20",
  name: "Egypt",
  flag: ""
}, {
  code: "+503",
  name: "El Salvador",
  flag: ""
}, {
  code: "+240",
  name: "Equatorial Guinea",
  flag: ""
}, {
  code: "+291",
  name: "Eritrea",
  flag: ""
}, {
  code: "+372",
  name: "Estonia",
  flag: ""
}, {
  code: "+251",
  name: "Ethiopia",
  flag: ""
}, {
  code: "+679",
  name: "Fiji",
  flag: ""
}, {
  code: "+358",
  name: "Finland",
  flag: ""
}, {
  code: "+33",
  name: "France",
  flag: ""
}, {
  code: "+241",
  name: "Gabon",
  flag: ""
}, {
  code: "+220",
  name: "Gambia",
  flag: ""
}, {
  code: "+995",
  name: "Georgia",
  flag: ""
}, {
  code: "+49",
  name: "Germany",
  flag: ""
}, {
  code: "+233",
  name: "Ghana",
  flag: ""
}, {
  code: "+30",
  name: "Greece",
  flag: ""
}, {
  code: "+1",
  name: "Grenada",
  flag: ""
}, {
  code: "+502",
  name: "Guatemala",
  flag: ""
}, {
  code: "+224",
  name: "Guinea",
  flag: ""
}, {
  code: "+245",
  name: "Guinea-Bissau",
  flag: ""
}, {
  code: "+592",
  name: "Guyana",
  flag: ""
}, {
  code: "+509",
  name: "Haiti",
  flag: ""
}, {
  code: "+504",
  name: "Honduras",
  flag: ""
}, {
  code: "+36",
  name: "Hungary",
  flag: ""
}, {
  code: "+354",
  name: "Iceland",
  flag: ""
}, {
  code: "+91",
  name: "India",
  flag: ""
}, {
  code: "+62",
  name: "Indonesia",
  flag: ""
}, {
  code: "+98",
  name: "Iran",
  flag: ""
}, {
  code: "+964",
  name: "Iraq",
  flag: ""
}, {
  code: "+353",
  name: "Ireland",
  flag: ""
}, {
  code: "+972",
  name: "Israel",
  flag: ""
}, {
  code: "+39",
  name: "Italy",
  flag: ""
}, {
  code: "+1",
  name: "Jamaica",
  flag: ""
}, {
  code: "+81",
  name: "Japan",
  flag: ""
}, {
  code: "+962",
  name: "Jordan",
  flag: ""
}, {
  code: "+7",
  name: "Kazakhstan",
  flag: ""
}, {
  code: "+254",
  name: "Kenya",
  flag: ""
}, {
  code: "+686",
  name: "Kiribati",
  flag: ""
}, {
  code: "+965",
  name: "Kuwait",
  flag: ""
}, {
  code: "+996",
  name: "Kyrgyzstan",
  flag: ""
}, {
  code: "+856",
  name: "Laos",
  flag: ""
}, {
  code: "+371",
  name: "Latvia",
  flag: ""
}, {
  code: "+961",
  name: "Lebanon",
  flag: ""
}, {
  code: "+266",
  name: "Lesotho",
  flag: ""
}, {
  code: "+231",
  name: "Liberia",
  flag: ""
}, {
  code: "+218",
  name: "Libya",
  flag: ""
}, {
  code: "+423",
  name: "Liechtenstein",
  flag: ""
}, {
  code: "+370",
  name: "Lithuania",
  flag: ""
}, {
  code: "+352",
  name: "Luxembourg",
  flag: ""
}, {
  code: "+389",
  name: "Macedonia",
  flag: ""
}, {
  code: "+261",
  name: "Madagascar",
  flag: ""
}, {
  code: "+265",
  name: "Malawi",
  flag: ""
}, {
  code: "+60",
  name: "Malaysia",
  flag: ""
}, {
  code: "+960",
  name: "Maldives",
  flag: ""
}, {
  code: "+223",
  name: "Mali",
  flag: ""
}, {
  code: "+356",
  name: "Malta",
  flag: ""
}, {
  code: "+692",
  name: "Marshall Islands",
  flag: ""
}, {
  code: "+222",
  name: "Mauritania",
  flag: ""
}, {
  code: "+230",
  name: "Mauritius",
  flag: ""
}, {
  code: "+52",
  name: "Mexico",
  flag: ""
}, {
  code: "+691",
  name: "Micronesia",
  flag: ""
}, {
  code: "+373",
  name: "Moldova",
  flag: ""
}, {
  code: "+377",
  name: "Monaco",
  flag: ""
}, {
  code: "+976",
  name: "Mongolia",
  flag: ""
}, {
  code: "+382",
  name: "Montenegro",
  flag: ""
}, {
  code: "+212",
  name: "Morocco",
  flag: ""
}, {
  code: "+258",
  name: "Mozambique",
  flag: ""
}, {
  code: "+95",
  name: "Myanmar",
  flag: ""
}, {
  code: "+264",
  name: "Namibia",
  flag: ""
}, {
  code: "+674",
  name: "Nauru",
  flag: ""
}, {
  code: "+977",
  name: "Nepal",
  flag: ""
}, {
  code: "+31",
  name: "Netherlands",
  flag: ""
}, {
  code: "+64",
  name: "New Zealand",
  flag: ""
}, {
  code: "+505",
  name: "Nicaragua",
  flag: ""
}, {
  code: "+227",
  name: "Niger",
  flag: ""
}, {
  code: "+234",
  name: "Nigeria",
  flag: ""
}, {
  code: "+850",
  name: "North Korea",
  flag: ""
}, {
  code: "+47",
  name: "Norway",
  flag: ""
}, {
  code: "+968",
  name: "Oman",
  flag: ""
}, {
  code: "+92",
  name: "Pakistan",
  flag: ""
}, {
  code: "+680",
  name: "Palau",
  flag: ""
}, {
  code: "+507",
  name: "Panama",
  flag: ""
}, {
  code: "+675",
  name: "Papua New Guinea",
  flag: ""
}, {
  code: "+595",
  name: "Paraguay",
  flag: ""
}, {
  code: "+51",
  name: "Peru",
  flag: ""
}, {
  code: "+63",
  name: "Philippines",
  flag: ""
}, {
  code: "+48",
  name: "Poland",
  flag: ""
}, {
  code: "+351",
  name: "Portugal",
  flag: ""
}, {
  code: "+974",
  name: "Qatar",
  flag: ""
}, {
  code: "+40",
  name: "Romania",
  flag: ""
}, {
  code: "+7",
  name: "Russia",
  flag: ""
}, {
  code: "+250",
  name: "Rwanda",
  flag: ""
}, {
  code: "+1",
  name: "Saint Kitts and Nevis",
  flag: ""
}, {
  code: "+1",
  name: "Saint Lucia",
  flag: ""
}, {
  code: "+1",
  name: "Saint Vincent and the Grenadines",
  flag: ""
}, {
  code: "+685",
  name: "Samoa",
  flag: ""
}, {
  code: "+378",
  name: "San Marino",
  flag: ""
}, {
  code: "+239",
  name: "Sao Tome and Principe",
  flag: ""
}, {
  code: "+966",
  name: "Saudi Arabia",
  flag: ""
}, {
  code: "+221",
  name: "Senegal",
  flag: ""
}, {
  code: "+381",
  name: "Serbia",
  flag: ""
}, {
  code: "+248",
  name: "Seychelles",
  flag: ""
}, {
  code: "+232",
  name: "Sierra Leone",
  flag: ""
}, {
  code: "+65",
  name: "Singapore",
  flag: ""
}, {
  code: "+421",
  name: "Slovakia",
  flag: ""
}, {
  code: "+386",
  name: "Slovenia",
  flag: ""
}, {
  code: "+677",
  name: "Solomon Islands",
  flag: ""
}, {
  code: "+252",
  name: "Somalia",
  flag: ""
}, {
  code: "+27",
  name: "South Africa",
  flag: ""
}, {
  code: "+82",
  name: "South Korea",
  flag: ""
}, {
  code: "+211",
  name: "South Sudan",
  flag: ""
}, {
  code: "+34",
  name: "Spain",
  flag: ""
}, {
  code: "+94",
  name: "Sri Lanka",
  flag: ""
}, {
  code: "+249",
  name: "Sudan",
  flag: ""
}, {
  code: "+597",
  name: "Suriname",
  flag: ""
}, {
  code: "+268",
  name: "Swaziland",
  flag: ""
}, {
  code: "+46",
  name: "Sweden",
  flag: ""
}, {
  code: "+41",
  name: "Switzerland",
  flag: ""
}, {
  code: "+963",
  name: "Syria",
  flag: ""
}, {
  code: "+886",
  name: "Taiwan",
  flag: ""
}, {
  code: "+992",
  name: "Tajikistan",
  flag: ""
}, {
  code: "+255",
  name: "Tanzania",
  flag: ""
}, {
  code: "+66",
  name: "Thailand",
  flag: ""
}, {
  code: "+670",
  name: "Timor-Leste",
  flag: ""
}, {
  code: "+228",
  name: "Togo",
  flag: ""
}, {
  code: "+676",
  name: "Tonga",
  flag: ""
}, {
  code: "+1",
  name: "Trinidad and Tobago",
  flag: ""
}, {
  code: "+216",
  name: "Tunisia",
  flag: ""
}, {
  code: "+90",
  name: "Turkey",
  flag: ""
}, {
  code: "+993",
  name: "Turkmenistan",
  flag: ""
}, {
  code: "+688",
  name: "Tuvalu",
  flag: ""
}, {
  code: "+256",
  name: "Uganda",
  flag: ""
}, {
  code: "+380",
  name: "Ukraine",
  flag: ""
}, {
  code: "+971",
  name: "United Arab Emirates",
  flag: ""
}, {
  code: "+44",
  name: "United Kingdom",
  flag: ""
}, {
  code: "+598",
  name: "Uruguay",
  flag: ""
}, {
  code: "+998",
  name: "Uzbekistan",
  flag: ""
}, {
  code: "+678",
  name: "Vanuatu",
  flag: ""
}, {
  code: "+379",
  name: "Vatican City",
  flag: ""
}, {
  code: "+58",
  name: "Venezuela",
  flag: ""
}, {
  code: "+84",
  name: "Vietnam",
  flag: ""
}, {
  code: "+967",
  name: "Yemen",
  flag: ""
}, {
  code: "+260",
  name: "Zambia",
  flag: ""
}, {
  code: "+263",
  name: "Zimbabwe",
  flag: ""
}];
export default function DemoBookingForm() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3626" id="demo-booking-form" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701638/img/modern_office_workspace.webp)]" />
      <div className="absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, hsla(0, 0%, 4%, 0.4) 0%, hsla(0, 0%, 4%, 0.85) 70%, hsla(0, 0%, 2%, 0.95) 100%)"
    }} />
      <div className="absolute inset-0 bg-background/60" />

      <div className="absolute inset-0 mix-blend-overlay opacity-30" style={{
      background: "radial-gradient(circle at 30% 40%, hsla(45, 92%, 60%, 0.15) 0%, transparent 50%)"
    }} />

      <div className="absolute top-0 left-0 right-0 h-px bg-border/60" />

      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[1600px] flex-col px-6 pt-24 pb-32 sm:px-10 lg:px-16">
        <div className="grid flex-1 grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          <div ref={headlineRef} className={`lg:col-span-9 flex flex-col justify-center transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-primary" />
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
                N° 001 — Request Access
              </span>
            </div>

            <h1 className="font-default font-bold uppercase leading-[0.85] tracking-tight text-foreground">
              <span className="block text-[clamp(3rem,10vw,8rem)]">SOLICITA</span>
              <span className="block text-[clamp(3rem,10vw,8rem)] sm:pl-[8vw] lg:pl-[120px]">TU DEMO</span>
            </h1>

            <div className="my-10 h-[2px] w-20 bg-primary" />

            <p className="font-serif italic text-lg sm:text-xl text-muted-foreground max-w-[520px] leading-relaxed mb-12">
              Experimenta cómo TimeArrival transforma la logística con precisión en tiempo real.
            </p>

            <div className="max-w-2xl">
              <FormProvider formId="demo_booking_form" sectionName="DemoBookingForm" defaultValues={{
              fullName: "",
              email: "",
              resortName: "",
              phone: "",
              message: ""
            }} submitText="SOLICITAR PRESENTACION" successMessage="Gracias. Nuestro equipo se pondrá en contacto pronto para confirmar tu sesión de demostración.">
                <BookingFormInner />
              </FormProvider>
            </div>
          </div>

          <div ref={metaRef} className={`hidden lg:col-span-3 lg:flex items-stretch justify-end transition-all duration-1000 delay-300 ease-out ${metaVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative flex items-center">
              <div className="absolute right-0 top-0 bottom-0 w-px bg-border/60" />
              <div className="font-mono text-xs uppercase text-muted-foreground tracking-[0.2em] whitespace-nowrap pr-6" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>
                N° 001 / EST. INNOVACIÓN DIGITAL / 47°36'N 122°19'W / PROYECTO 24.11
              </div>
            </div>
          </div>
        </div>

        <div className="relative z-10 mt-16 flex flex-col gap-8">
          <div className="flex items-center gap-3">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
              Scroll
            </span>
            <ChevronDown className="size-4 text-primary animate-bounce" />
          </div>

          <div className="h-px w-full bg-border/60" />
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-border/60" />
    </section>;
}
function BookingFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-primary/5 border border-primary/20 rounded-lg flex flex-col items-center text-center animate-in fade-in slide-in-from-bottom-4 duration-500">
        <CheckCircle className="size-12 text-primary mb-4" />
        <h3 className="text-xl font-bold mb-2 uppercase tracking-wider">Solicitud Recibida</h3>
        <p className="text-muted-foreground mb-6 max-w-md">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="font-mono text-xs uppercase tracking-widest">
          Enviar Otra Solicitud
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
        <FormField control={control} name="fullName" rules={{
        required: "El nombre completo es requerido"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Nombre Completo</FormLabel>
              <FormControl>
                <Input placeholder="Juan Pérez" className="bg-transparent border-0 border-b-2 border-input focus-visible:ring-0 focus-visible:border-primary transition-colors px-0 h-12" {...field} />
              </FormControl>
              <FormMessage className="text-[10px] uppercase tracking-wider" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "El correo electrónico es requerido",
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: "Dirección de correo electrónico inválida"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Correo Electrónico</FormLabel>
              <FormControl>
                <Input type="email" placeholder="juan@resort.com" className="bg-transparent border-0 border-b-2 border-input focus-visible:ring-0 focus-visible:border-primary transition-colors px-0 h-12" {...field} />
              </FormControl>
              <FormMessage className="text-[10px] uppercase tracking-wider" />
            </FormItem>} />
      </div>

      <div className="mb-6">
        <FormField control={control} name="resortName" rules={{
        required: "El nombre del resort es requerido"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Nombre del Resort / Propiedad</FormLabel>
              <FormControl>
                <Input placeholder="Resort Grand Horizon" className="bg-transparent border-0 border-b-2 border-input focus-visible:ring-0 focus-visible:border-primary transition-colors px-0 h-12" {...field} />
              </FormControl>
              <FormMessage className="text-[10px] uppercase tracking-wider" />
            </FormItem>} />
      </div>

      <div className="mb-6">
        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Número de Teléfono (Opcional)</FormLabel>
              <FormControl>
                <div className="flex gap-2 items-end">
                  <Select defaultValue="+1">
                    <SelectTrigger className="w-[100px] bg-transparent border-0 border-b-2 border-input focus:ring-0 focus:border-primary transition-colors px-0 h-12">
                      <SelectValue placeholder="+1 " />
                    </SelectTrigger>
                    <SelectContent className="[&_[data-slot=select-item]_span]:hidden">
                      {countries.map((country, i) => <SelectItem key={`${country.code}-${i}`} value={country.code} data-index={i}>
                          {country.flag} {country.code} {country.name}
                        </SelectItem>)}
                    </SelectContent>
                  </Select>
                  <Input type="tel" placeholder="555-0123" className="flex-1 bg-transparent border-0 border-b-2 border-input focus-visible:ring-0 focus-visible:border-primary transition-colors px-0 h-12" {...field} />
                </div>
              </FormControl>
              <FormMessage className="text-[10px] uppercase tracking-wider" />
            </FormItem>} />
      </div>

      <div className="mb-8">
        <FormField control={control} name="message" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Detalles Adicionales (Opcional)</FormLabel>
              <FormControl>
                <Textarea placeholder="Cuéntanos más acerca de tus necesidades específicas" className="bg-transparent border-0 border-b-2 border-input focus-visible:ring-0 focus-visible:border-primary transition-colors px-0 min-h-[100px] resize-none" {...field} />
              </FormControl>
              <FormMessage className="text-[10px] uppercase tracking-wider" />
            </FormItem>} />
      </div>

      {submitError && <div className="mb-6 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
          <p className="text-destructive text-xs uppercase tracking-wider">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} size="lg" className="group w-full sm:w-auto h-14 px-12 bg-primary text-primary-foreground font-default font-bold uppercase tracking-wider text-sm shadow-2xl hover:bg-primary hover:shadow-[0_0_32px_hsla(45,92%,60%,0.7)] transition-all duration-300 rounded-lg">
        {isSubmitting ? <>
            <Loader className="mr-2 size-4 animate-spin" />
            Processing...
          </> : "SOLICITAR PRESENTACION"}
      </Button>
    </Form>;
}